<template>
  <div>
    <h4 class="mb-4">Similar RTPs</h4>
    <div v-if="amReady">
      <el-collapse :key="key" @change="handleChange"
                   class="mb-2" v-for="(destinations, key) in similarDestinations" v-model="activeDestinations">
        <el-collapse-item :name="key">
          <template slot="title">
            <div class="ml-2">
              <!--<i class="header-icon el-icon-info"></i>-->
              <h6 class="text-uppercase mb-0">{{ key }}</h6>
            </div>
          </template>
          <div :key="desIndex" class="ml-4" v-for="(destination, desIndex) in destinations">
            <el-tag style="font-size: 16px">RTP Segment: {{ desIndex }}</el-tag>
            <div :key="rtpIndex" class="ml-4" v-for="(rtp, rtpIndex) in destination">
              <div>
                {{ rtp.rtp_1 + ' - ' + rtp.vendor_1 }}
              </div>
              <div>
                {{ rtp.rtp_2 + ' - ' + rtp.vendor_2 }}
              </div>
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import actionsCell from './ag-grid/ActionsCell'
import module from './../index.js'
import {notify} from '@/system-services/notify.js'

export default {
  watch: {
    searchMe: function (val) {
      this.agGrid.gridApi.setQuickFilter(val);
    }
  },
  data() {
    return {
      activeDestinations: [],
      searchMe: null,
      module: {
        ...module
      },
      amReady: false,
      editMode: false,
      dialogVisible: false,
      rowsCounter: 0,
      dataToBind: null,
      rowToEdit: null,
      similarDestinations: {}
    };
  },
  mounted() {
    this.$store.dispatch(this.module.info.name + '-api/list').then(records => {
      for (let record in records) {
        let segment = records[record].rtp.split('.')
        segment.pop()
        segment = segment.join('.')

        if (segment == '') {
          continue
        }

        for (let similarRecord in records) {
          let similarSegment = records[similarRecord].rtp.split('.')
          similarSegment.pop()
          similarSegment = similarSegment.join('.')

          if (records[similarRecord].id !== records[record]) {

            let destination = records[record].destination
            if (similarSegment == segment && record.destination == similarRecord.destination) {
              if (!this.similarDestinations.hasOwnProperty(record.destination)) {
                this.similarDestinations[destination] = {}
              }

              if (!this.similarDestinations[destination].hasOwnProperty(segment)) {
                this.similarDestinations[destination][segment] = []
              }

              if (records[record].vendor != records[similarRecord].vendor) {
                this.similarDestinations[destination][segment].push({
                  vendor_1: records[record].vendor,
                  vendor_2: records[similarRecord].vendor,
                  rtp_1: records[record].rtp,
                  rtp_2: records[similarRecord].rtp
                })
              }

            }
          }
        }
      }

      for(let dest in this.similarDestinations) {
        if(Object.keys(this.similarDestinations[dest]).length == 1) {
          for (let segment in this.similarDestinations[dest]) {
            if(Object.keys(this.similarDestinations[dest][segment]).length == 0) {
              delete this.similarDestinations[dest]
            }
          }
        }
      }

      this.amReady = true
    })
  },
  methods: {
    handleChange(val) {
      console.log(val);
    }
  }
}
</script>
